module.exports = "/virtual-football-league/img/video/clubs/italy/milan.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/video/clubs/italy/milan.png
// module id = 351
// module chunks = 4